<template>
	<div>
		<div class="rt-navigation-bar-container">
			<login-nav-bar class="rt-navigation-bar" :homeIcon="homeIcon" v-if="isLoginNavBar"/>
			<!-- signup nav bar: 2nd or 3rd step at signup -->
			<signup-nav-bar
				:signupStep="currentNavStep"
				:signupTitle="signupNavTitle"
				:homeIcon="homeIcon"
				:shouldShowSignupNavButtons="shouldShowSignupNavButtons"
				:isStudentNav="isStudentSignupNav"
				@stepCompleted="handleStepCompleted"
				v-if="shouldShowSignupNav"
			/>
			<!-- common nav bar after login -->
			<common-nav-bar class="rt-navigation-bar" :class="{'teacher-navbar': isTeacherNav}"
			  	:isTeacherNav="isTeacherNav"
				:isMobileNav="isMobile"
				:username="currentUsername"
				:userIcon="userIcon"
				:avatarColor="avatarColor"
				:showPremium="premiumOptionVisible"
				:showActivityRibbon="isActivityRibbonVisible"
				:showSalesRibbon="isSalesRibbonVisible"
				:currentNavName="currentNav"
				:leftNavButtons="leftNavButtons"
				:dropdownButtons="dropdownButtons"
				@dropdownClicked="handleDropdownEvent"
				@pemiumButtonClicked="openSubscriptionDialog"
				@onShowSubscribe="openSubscriptionDialog"
				v-if="isCommonNavBar"
			/>
			<!-- show dialogs -->
			<profile-settings-modal :show="settingModalOpened" @onSubscription="isSubscriptionDialogOpened=true" @close="closeProfileModal" />
			<subscription-dialog :show="isSubscriptionDialogOpened" name="navigation-subscription-modal" @closeDialog="isSubscriptionDialogOpened=false"></subscription-dialog>
			<my-teacher-modal :show="teacherModalOpened" @close="closeTeacherModal"/>
		</div>
	</div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import _ from 'lodash';
  import LoginNavBar from './LoginNavBar.vue';
  import SignupNavBar from './SignupNavBar.vue';
  import CommonNavBar from './CommonNavBar.vue';
  import ProfileSettingsModal from '../ProfileSettingsModal.vue';
  import SubscriptionDialog from '../../teacher/SubscriptionDialog.vue';
  import MyTeacherModal from '../../student/MyTeacherModal.vue';
  import { constants, enums } from "config";
  import Utils from 'common/Utils';
  import { NAVIGATION } from './navigation';
  import { isLoggedIn, isTeacher, isStudent, getUser, getStudent, isAdmin, isSocialAuth } from 'common/UserService';
  import {isSubscriptionActive} from '../../../../common/UserService';
  import {reportPricingTableOpened} from '../../../../common/reporting';
  import {logout} from '../../../../common/authtoken';
  import {getTeachers} from "../../../../common/api";

  export default {
	computed: {
	  ...mapState('teacher', ['signupStatus', 'signupABTest']),
	  ...mapState('student', {
			studentAge: state => state.age
	  }),
	  isTeacherNav() {
		return isTeacher();
	  },
	  isStudentSignupNav() {
			return isStudent() && isSocialAuth && !this.studentAge && location.pathname === '/app/sign-up/more-info';
	  },
		isLoginNavBar() {
			return this.currentNavStep === enums.signUpStatus.SIGN;
		},
		isCommonNavBar() {
			return this.currentNavStep === enums.signUpStatus.COMMON;
		},
	  shouldShowSignupNav() {
			return (this.isTeacherNav && this.currentNavStep > enums.signUpStatus.SIGN && this.currentNavStep < enums.signUpStatus.COMMON) || this.isStudentSignupNav;
	  },
	  homeIcon() {
		switch (this.currentNavStep) {
		  case 1: return !this.isMobile ? `${constants.ASSETS_BASE_DIR}/quiz/icon-title-logo.png` : `${constants.ASSETS_BASE_DIR}/quiz/icon-header-logo.svg`;
		  case 2: return !this.isMobile ? `${constants.ASSETS_BASE_DIR}/signup/icon-logo.svg` : `${constants.ASSETS_BASE_DIR}/quiz/icon-header-logo.svg`;
		  default: return '';
		}
	  },
	  signupNavTitle() {
			return constants.SIGNUP_STATUS_TO_STEP[this.currentNavStep.toString()]?.name;
	  },
	  shouldShowSignupNavButtons() {
      debugger;
		  return this.signupStatus && (this.currentNavStep === enums.signUpStatus.SCHOOL_INFO || this.currentNavStep === enums.signUpStatus.CREATE_CLASS || this.currentNavStep === enums.signUpStatus.PRICING);
	  },
	  currentUsername() {
      	return Utils.getCurrentUserDisplayName() || getUser()?.username;
	  },
	  userIcon() {
		const avatarIcon = Utils.getUserSetting(getUser(), 'avatarIcon');
      	return avatarIcon ? avatarIcon : null;
	  },
	  avatarColor() {
		const avatarBGColor = Utils.getUserSetting(getUser(), 'avatarColor');
      	return avatarBGColor ? avatarBGColor : null;
	  },
	  isActivityRibbonVisible() {
      return false;
		// const user = getUser();
		// return isTeacher() //only teachers
    //       && !_.isEmpty(user.email) //with email
    //       && !_.isEmpty(getClasses()) //and classes
    //       && !localStorage.getItem('competition_ribbon'); //and did not dismiss this
	  },
	  isSalesRibbonVisible() {
      return false;
		//   return isTeacher() &&
    //     !this.isPremium //only non-premium teachers
    //     //   && !_.isEmpty(user.email) //with email
		// //   && !_.isEmpty(getClasses()) //and classes
    //       && !localStorage.getItem('sales_alert'); //and did not dismiss this
	  }
	},
	data: function() {
	  return {
      currentNavStep: 0,
      currentNav: '',
      leftNavButtons: [],
      dropdownButtons: [],
      isMobile: false,
      isSubscriptionDialogOpened: false,
      settingModalOpened: false,
      teacherModalOpened: false,
      premiumOptionVisible: false
	  }
	},
	components: {
	  LoginNavBar,
	  SignupNavBar,
	  CommonNavBar,
	  ProfileSettingsModal,
	  MyTeacherModal,
	  SubscriptionDialog
	},
	watch: {
	  signupStatus(newVal) {
		if (newVal) {
		  this.updateCurrentNavStep();
		}
	  },
		studentAge(newVal) {
			if (newVal) {
				this.updateCurrentNavStep();
			}
	  }
	},
	async created() {
	  if (isLoggedIn()) {
    	if (isAdmin()) {
          this.leftNavButtons = NAVIGATION.admin.left || [];
          this.dropdownButtons = NAVIGATION.admin.dropdown || [];
    	}
		else if (this.isTeacherNav) {
		  const originalLeftNavs = NAVIGATION.teacher.left || [];
		  this.leftNavButtons = Utils.isActivityFeatureEnabled() ? originalLeftNavs : originalLeftNavs.filter(item => item.name !== 'Activities');
		  this.dropdownButtons = NAVIGATION.teacher.dropdown || [];
		} else {
		  this.leftNavButtons = NAVIGATION.student.left || [];
		  this.dropdownButtons = NAVIGATION.student.dropdown || [];
		}

		const navButtons = [
			...this.leftNavButtons,
			...this.dropdownButtons
		];
		if (location.pathname === '/' && navButtons.length > 0) {
		  this.currentNav = navButtons[0].name;
		} else {
		  navButtons.forEach(navItem => {
			if (navItem.href && navItem.href.includes(location.pathname)) {
			  this.currentNav = navItem.name;
			}
		  });
		}
	  }

		// update store for student with age value when signup with student
		if (isStudent()) {
			this.updateAge(getStudent().dob);
	  }

	  this.updateCurrentNavStep();

	  if (Utils.getWindowWidth() < 768) {
		this.isMobile = true;
	  }
	  window.addEventListener('resize', this.handleResizeWindow);
    this.premiumOptionVisible = await this.isPremiumOptionVisible();
	},
	destroyed() {
	  window.removeEventListener('resize', this.handleResizeWindow);
	},
	mounted() {
	  if (!location.pathname.includes('/user/manage')) {
		const el = document.querySelector('#footer-list')
      	if (el) el.style.display='none'
	  }
	  if (location.hash.includes('#add_teachers_dialog') && getUser()) {
	    this.teacherModalOpened = true;
	  }
	  if (location.hash.includes('#add_profile_dialog') && getUser()) {
	    this.settingModalOpened = true;
	  }
	},
	methods: {
		...mapMutations('student', ['updateAge']),
	  updateCurrentNavStep() {
		if (!isLoggedIn()) {
		  this.currentNavStep = 1;
		} else if (this.isTeacherNav && this.signupStatus) {
		  this.currentNavStep = constants.SIGNUP_STATUS_TO_STEP[this.signupStatus].step;
		} else if (this.isStudentSignupNav) {
		  this.currentNavStep = enums.signUpStatus.UPDATE_INFO; // age updating nav bar(personal details for student while signing up)
		} else {
		  this.currentNavStep = enums.signUpStatus.COMMON; // common nav bar
		}
	  },
	  handleResizeWindow() {
		this.isMobile = Utils.getWindowWidth() < 768;
	  },
	  openSubscriptionDialog() {
		this.isSubscriptionDialogOpened = true;
		reportPricingTableOpened('top_menu_try_premium_btn');
	  },
	  openMyTeachersDialog() {
		if (!location.hash) {
		  location.href += '#add_teachers_dialog';
		}
		this.teacherModalOpened = true;
	  },
	  openSettingDialog() {
		if (!location.hash) {
		  location.href += '#add_profile_dialog';
		}
		this.settingModalOpened = true;
	  },
	  handleDropdownEvent(dropdownType, event) {
        if (dropdownType === 'logout' || (dropdownType === 'premiumNavItem' && !this.isSubscriptionDialogOpened) || dropdownType === 'myTeachersNavItem' || dropdownType === 'profileNavItem') {
          event.preventDefault();
          event.stopPropagation();
        }
	    if (dropdownType === 'logout') {
		  logout()
	    }
		if (dropdownType === 'premiumNavItem' && !this.isSubscriptionDialogOpened) {
		  this.openSubscriptionDialog();
		}
		if (dropdownType === 'myTeachersNavItem') {
		  this.openMyTeachersDialog();
		}
		if (dropdownType === 'profileNavItem') {
		  this.openSettingDialog();
		}
	  },
	  closeTeacherModal(mustReload) {
		this.teacherModalOpened = false;
		if (location.hash.includes('#add_teachers_dialog')) {
			const baseUrl = location.href.split('#add_teachers_dialog')[0]
			history.replaceState(null, null, baseUrl);
		}
		if (mustReload) {
			location.reload();
		}
	  },
	  closeProfileModal(profileUpdated) {
		this.settingModalOpened = false;
		if (location.hash.includes('#add_profile_dialog')) {
		  const baseUrl = location.href.split('#add_profile_dialog')[0]
		  history.replaceState(null, null, baseUrl);
		}
		if (profileUpdated) {
		  location.reload();
		}
	  },
		handleStepCompleted(step) {
			this.$emit('stepCompleted', { step, abtest: this.signupABTest });
		},
    async isPremiumOptionVisible() {
      if (isSubscriptionActive()) {
        return false;
      } else {
        if (isTeacher()) {
          return true;
        } else {
          //Check if any of the teachers has an active subscription
          const result = await getTeachers();
          if (result.success && result?.data?.currentInvites?.length > 0) {
            const teachers = result.data.currentInvites;
            for (const teacher of teachers) {
              if (this.isTeacherSubscriptionActive(teacher)) {
                return false;
              }
            }
          }
          return true;
        }
      }
    },
    isTeacherSubscriptionActive(teacher) {
      try {
        if (teacher.teacherSettings) {
          const teacherSettings = JSON.parse(teacher.teacherSettings);
          return _.result(teacherSettings, 'subscription.active', false);
        }
      } catch (error) {
        //Error
      }
      return false;
    },
	}
  }

</script>

<style scoped lang="scss">

  @import './navigation';

  .rt-navigation-bar-container {
    width: 100%;
    background: $light-blue;
    border-bottom: 1px solid #eee;
	color: $title-dark-grey;
	position: relative;
	z-index: 99902;
  }

  .rt-navigation-bar {
  	&.teacher-navbar {
	  max-width: 1440px;
	}
  }

</style>
